import { Backdrop, Box, ClickAwayListener, Tooltip, TooltipProps } from '@mui/material';
import { ReactNode } from 'react';

type FiltersDropdownContainerProps = {
  opened: boolean;
  onOpen: (...args: any[]) => void;
  onClose: (...args: any[]) => void;
  disabled?: boolean;
  width: number;
  title?: ReactNode;
  testId?: string;
  renderClosed: () => ReactNode;
  renderOpened: () => ReactNode;
} & Partial<TooltipProps>;

export const FiltersDropdownContainer = ({
  opened,
  onOpen,
  onClose,
  disabled,
  width,
  title,
  testId,
  renderClosed,
  renderOpened,
  ...tooltipProps
}: FiltersDropdownContainerProps) => {
  return (
    <>
      <Backdrop open={opened} invisible sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} />
      <ClickAwayListener onClickAway={onClose}>
        <div data-test-id={testId}>
          <Tooltip
            PopperProps={{
              disablePortal: true,
            }}
            onClose={onClose}
            open={opened}
            placement="bottom-start"
            componentsProps={{
              tooltip: {
                sx: (theme) => ({
                  width,
                  maxWidth: width,
                  borderRadius: theme.spacing(1),
                  border: `1px solid ${theme.palette.common.light3}`,
                  padding: 0,
                  overflow: 'hidden',
                  margin: `${theme.spacing(0.5, 0, 0)} !important`,
                }),
              },
            }}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={title}
            {...tooltipProps}
          >
            <Box
              flexDirection="row"
              sx={{
                cursor: disabled ? 'default' : 'pointer',
                position: 'relative',
                zIndex: (theme) => (opened ? theme.zIndex.drawer + 2 : undefined),
              }}
              alignItems="center"
              onClick={() => {
                if (!disabled) {
                  onOpen();
                }
              }}
            >
              {!opened ? renderClosed() : renderOpened()}
            </Box>
          </Tooltip>
        </div>
      </ClickAwayListener>
    </>
  );
};
